<template>
	<div class="resume">
		<el-container>
			<el-header class="personalheader">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的用户{{showId}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="gotohome()">招聘首页</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="personalaside">
					<el-menu default-active="3" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoresume()">
							<span class="menuText" slot="title">个人简历</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotocollect()">
							<span class="menuText" slot="title">已收藏岗位</span>
						</el-menu-item>
						<el-menu-item index="3" @click="gotosubmit()">
							<span class="menuText" slot="title">我的投递</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="personalbody">
					<div class="resumecontent">
						<el-table :data="queryResumuList" stripe style="width: 100%">
							<template slot="empty">
								<img src="../../image/noneposition.png" class="nonepositionimgPersonal" />
								<div class="noCart">
									您还尚未申请心仪的岗位，快去尝试一下吧！
									<router-link to="/">前去查看</router-link>
								</div>
							</template>
							<!-- <el-table-column prop="order" label="投递志愿">
							</el-table-column> -->
							<el-table-column prop="position_name" label="岗位名称">
							</el-table-column>
							<el-table-column prop="status" label="岗位状态">
							</el-table-column>
							<!-- <el-table-column prop="base" label="地址">
							</el-table-column>
							<el-table-column prop="department" label="招聘单位">
							</el-table-column> -->
							<el-table-column prop="contact" label="联系人">
							</el-table-column>
							<el-table-column label="查看" width="100">
								<template slot-scope="scope">
									<el-button @click="dialogPositionInfo(scope.row)" icon="el-icon-search" type="text"
										size="small">查看
									</el-button>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="deleteQuery(scope.row)">取消申请</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-dialog title="岗位信息" :visible.sync="dialogPositionStats" width="40%">
							<div class="temtitle">
								<div class="jobnamePersonal">岗位名称： &nbsp&nbsp{{queryResumuList.position_name}}</div>
								<!-- <div class="positionInfo">
									招聘单位： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{queryResumuList.department}}
									</span>
								</div><br />
								<div class="positionInfo">
									工作地点： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{queryResumuList.base}}
									</span>
								</div><br />
								<div class="positionInfo">
									发布时间： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{queryResumuList.update_time}}
									</span>
								</div><br />
								<div class="positionInfo">
									任职资格：<br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{queryResumuList.requirements}}
									</span>
								</div><br /> -->
								<!-- 	<div class="positionInfo">
									工作职责： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{queryResumuList.responsibilities}}
									</span>
								</div><br /> -->
								<div class="positionInfo">
									招聘条件： <br />
									<span class="info" style="white-space: pre-wrap;">
										{{queryResumuList.responsibilities}}
									</span>
								</div><br />
								<div class="positionInfo">
									联系人： <br />
									<span class="info">
										&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{queryResumuList.contact}}
									</span>
								</div><br />
							</div>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogPositionStats = false">关 闭</el-button>
							</span>
						</el-dialog>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loginstatus,
		Logout,
		queryRequestPosition,
		deleteRequestPosition,
	} from '../../api/user.js'
	export default {
		data() {
			return {
				dialogPositionStats: false,
				// requestOrderDialog: false,
				requestPositionInfo: {},
				queryResumuList: [{
						order: '',
						position_name: '',
						status: '',
						base: '',
						department: '',
						contact: '',
						position_id: '',
						update_time: '',
						requirements: '',
						responsibilities: '',
					},
					// {
					// 	order: '',
					// 	position_name: '',
					// 	status: '',
					// 	base: '',
					// 	department: '',
					// 	contact: '',
					// 	position_id: '',
					// 	update_time: '',
					// 	requirements: '',
					// 	responsibilities: '',
					// },
				],
				queryRequestPositionInfo: {},
				userId: '',
				showId: '',
			}
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					let str = res.data;
					this.showId = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userId = res.data;
					queryRequestPosition({
						userID: this.userId,
					}).then((res) => {
						if (res.data.length != 0) {
							this.queryResumuList[0].order = '第一志愿';
							this.queryResumuList[0].position_name = res.data[0].positionBo.position_name;
							if (res.data[0].positionBo.position_status == 1) {
								this.queryResumuList[0].status = '正在招聘'
							} else if (res.data[0].positionBo.position_status == 0) {
								this.queryResumuList[0].status = '已下线'
							}
							this.queryResumuList[0].base = res.data[0].positionBo.base;
							this.queryResumuList[0].department = res.data[0].positionBo.department;
							this.queryResumuList[0].contact = res.data[0].positionBo.contact;
							this.queryResumuList[0].position_id = res.data[0].positionBo.position_id;
							this.queryResumuList[0].update_time = timestampToTime(res.data[0].positionBo
								.update_time);
							this.queryResumuList[0].requirements = res.data[0].positionBo.requirements;
							this.queryResumuList[0].responsibilities = res.data[0].positionBo
								.responsibilities;
						}
						// if (res.data.length == 2 && res.data[0].order == 0) {
						// 	this.queryResumuList[0].order = '第一志愿';
						// 	this.queryResumuList[0].position_name = res.data[0].positionBo.position_name;
						// 	if (res.data[0].positionBo.position_status == 1) {
						// 		this.queryResumuList[0].status = '正在招聘'
						// 	} else if (res.data[0].positionBo.position_status == 0) {
						// 		this.queryResumuList[0].status = '已下线'
						// 	}
						// 	this.queryResumuList[0].base = res.data[0].positionBo.base;
						// 	this.queryResumuList[0].department = res.data[0].positionBo.department;
						// 	this.queryResumuList[0].contact = res.data[0].positionBo.contact;
						// 	this.queryResumuList[0].position_id = res.data[0].positionBo.position_id;
						// 	this.queryResumuList[0].update_time = timestampToTime(res.data[0].positionBo
						// 		.update_time);
						// 	this.queryResumuList[0].requirements = res.data[0].positionBo.requirements;
						// 	this.queryResumuList[0].responsibilities = res.data[0].positionBo
						// 		.responsibilities;
						// 	this.queryResumuList[1].order = '第二志愿';
						// 	this.queryResumuList[1].position_name = res.data[1].positionBo.position_name;
						// 	if (res.data[1].positionBo.position_status == 1) {
						// 		this.queryResumuList[1].status = '正在招聘'
						// 	} else if (res.data[1].positionBo.position_status == 0) {
						// 		this.queryResumuList[1].status = '已下线'
						// 	}
						// 	this.queryResumuList[1].base = res.data[1].positionBo.base;
						// 	this.queryResumuList[1].department = res.data[1].positionBo.department;
						// 	this.queryResumuList[1].contact = res.data[1].positionBo.contact;
						// 	this.queryResumuList[1].position_id = res.data[1].positionBo.position_id;
						// 	this.queryResumuList[1].update_time = timestampToTime(res.data[1].positionBo
						// 		.update_time);
						// 	this.queryResumuList[1].requirements = res.data[1].positionBo.requirements;
						// 	this.queryResumuList[1].responsibilities = res.data[1].positionBo
						// 		.responsibilities;
						// } else if (res.data.length == 1 && res.data[0].order == 1) {
						// 	this.queryResumuList[0].order = '第一志愿';
						// 	this.queryResumuList[0].position_name = '暂未投递';
						// 	this.queryResumuList[0].base = '暂未投递';
						// 	this.queryResumuList[0].department = '暂未投递';
						// 	this.queryResumuList[0].contact = '暂未投递';
						// 	this.queryResumuList[0].position_id = '暂未投递';
						// 	this.queryResumuList[0].update_time = '暂未投递';
						// 	this.queryResumuList[0].requirements = '暂未投递';
						// 	this.queryResumuList[0].responsibilities = '暂未投递';
						// 	this.queryResumuList[1].order = '第二志愿';
						// 	this.queryResumuList[1].position_name = res.data[0].positionBo.position_name;
						// 	if (res.data[1].positionBo.position_status == 1) {
						// 		this.queryResumuList[1].status = '正在招聘'
						// 	} else if (res.data[1].positionBo.position_status == 0) {
						// 		this.queryResumuList[1].status = '已下线'
						// 	}
						// 	this.queryResumuList[1].base = res.data[0].positionBo.base;
						// 	this.queryResumuList[1].department = res.data[0].positionBo.department;
						// 	this.queryResumuList[1].contact = res.data[0].positionBo.contact;
						// 	this.queryResumuList[1].position_id = res.data[0].positionBo.position_id;
						// 	this.queryResumuList[1].update_time = timestampToTime(res.data[0].positionBo
						// 		.update_time);
						// 	this.queryResumuList[1].requirements = res.data[0].positionBo.requirements;
						// 	this.queryResumuList[1].responsibilities = res.data[0].positionBo
						// 		.responsibilities;
						// } else if (res.data.length == 1 && res.data[0].order == 0) {
						// 	this.queryResumuList[0].order = '第一志愿';
						// 	this.queryResumuList[0].position_name = res.data[0].positionBo.position_name;
						// 	if (res.data[0].positionBo.position_status == 1) {
						// 		this.queryResumuList[0].status = '正在招聘'
						// 	} else if (res.data[0].positionBo.position_status == 0) {
						// 		this.queryResumuList[0].status = '已下线'
						// 	}
						// 	this.queryResumuList[0].base = res.data[0].positionBo.base;
						// 	this.queryResumuList[0].department = res.data[0].positionBo.department;
						// 	this.queryResumuList[0].contact = res.data[0].positionBo.contact;
						// 	this.queryResumuList[0].position_id = res.data[0].positionBo.position_id;
						// 	this.queryResumuList[0].update_time = timestampToTime(res.data[0].positionBo
						// 		.update_time);
						// 	this.queryResumuList[0].requirements = res.data[0].positionBo.requirements;
						// 	this.queryResumuList[0].responsibilities = res.data[0].positionBo
						// 		.responsibilities;
						// 	this.queryResumuList[1].order = '第二志愿';
						// 	this.queryResumuList[1].position_name = '暂未投递';
						// 	this.queryResumuList[1].base = '暂未投递';
						// 	this.queryResumuList[1].department = '暂未投递';
						// 	this.queryResumuList[1].contact = '暂未投递';
						// 	this.queryResumuList[1].position_id = '暂未投递';
						// 	this.queryResumuList[1].update_time = '暂未投递';
						// 	this.queryResumuList[1].requirements = '暂未投递';
						// 	this.queryResumuList[1].responsibilities = '暂未投递';
						// } else if (res.data.length == 0) {
						// 	this.queryResumuList = [];
						// }
					});
				} else if (res.code == 400) {
					this.$message({
						message: '未检测到登录信息！',
						type: 'error'
					});
					this.$router.push('/')
				}
			})
		},
		methods: {
			dialogPositionInfo(row) {
				this.queryResumuList = row;
				this.dialogPositionStats = true
			},
			deleteQuery(row) {
				this.$confirm('此操作将取消您对该岗位的申请, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (row.order == '第一志愿') {
						deleteRequestPosition({
							order: 0,
							positionID: row.position_id,
							userID: this.userId,
						}).then((res) => {
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '取消申请成功'
								});
								location.reload();
							} else {
								this.$message({
									type: 'warning',
									message: res.msg
								});
							}
						})
					} else if (row.order == '第二志愿') {
						deleteRequestPosition({
							order: 1,
							positionID: row.position_id,
							userID: this.userId,
						}).then((res) => {
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '第二志愿取消申请成功'
								});
								location.reload();
							} else {
								this.$message({
									type: 'warning',
									message: '取消申请失败'
								});
							}
						})
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消该操作'
					});
				});
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotohome() {
				this.$router.push('/')
			},
			gotoresume() {
				this.$router.push('/personal/resume')
			},
			gotocollect() {
				this.$router.push('/personal/collect')
			},
			// gotosubmit() {
			// 	this.$router.push('/personal/submit')
			// },
		},
	}

	function timestampToTime(timestamp) {
		timestamp = timestamp ? timestamp : null;
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		return Y + M + D;
	}
</script>

<style>
	@import url(../../assets/css/personal.css);
</style>
